import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CustomTable from "../../../components/customTable/CustomTable";
import { sipBookingApi } from "../../../app/slices/reports/sipBookingSlice";
import { partnerListApi } from "../../../app/slices/reports/partnerListSlice";
import SearchFilterComponent from "./SearchFilterComponent";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import ToastComponent from "../../../components/customTable/ToastComponent";

export default function SipBooking() {
  const dispatch = useDispatch();
  const bussinessSliceResponse1 = useSelector(
    (state) => state.sipBooking.sipBooking.data?.transactions,
  );
  // console.log("sipBookingSlice SliceResponse: ", bussinessSliceResponse1);

  function flattenObject(obj, parentKey = "", result = {}) {
    for (let key in obj) {
      const value = obj[key];
      const newKey = parentKey ? `${parentKey}__${key}` : key;

      if (
        value &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        flattenObject(value, newKey, result);
      } else {
        result[newKey] = value;
      }
    }
    return result;
  }
  // Flatten all transactions
  const bussinessSliceResponse = bussinessSliceResponse1?.map((transaction) =>
    flattenObject(transaction),
  );

  // console.log(bussinessSliceResponse);

  const totalAmount = useSelector(
    (state) => state.sipBooking.sipBooking.data?.totalAmount,
  );
  // console.log("sipBookingSlice total amount", totalAmount);

  const sliceResponse = useSelector(
    (state) => state.partnerList.partnerList.data,
  );

  const stateLoading = useSelector((state) => state.sipBooking.loading);

  const handleSearch = (params) => {
    // console.log("params: ", params);
    dispatch(sipBookingApi(params));
  };

  useEffect(() => {
    dispatch(partnerListApi());
    dispatch(sipBookingApi({})); // Trigger the API call without parameters
  }, [dispatch]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("Blockid", {
      header: "Blockid",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row?.original?.Blockid);
        return (
          <>
            <Tooltip title={cell.row?.original?.Blockid}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.Blockid}
          </>
        );
      },
    }),
    columnHelper.accessor("partner_id", {
      header: "partner_id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row?.original?.partner_id);
        return (
          <>
            <Tooltip title={cell.row?.original?.partner_id}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.partner_id}
          </>
        );
      },
    }),
    columnHelper.accessor("client_id___id", {
      header: "client_id",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () =>
          navigator.clipboard.writeText(cell.row?.original?.client_id___id);
        return (
          <>
            <Tooltip title={cell.row?.original?.client_id___id}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.client_id___id}
          </>
        );
      },
    }),

    columnHelper.accessor("client_id__name", {
      header: "Client Name",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.client_id__name}</div>,
    }),

    columnHelper.accessor("Price", {
      header: "Price",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.Price}</div>,
    }),

    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.amount}</div>,
    }),

    // columnHelper.accessor("partner_id", {
    //   header: "Partner ID",
    //   size: 30,
    //   Cell: ({ cell }) => <div>{cell.row?.original?.partner_id}</div>,
    // }),

    columnHelper.accessor("proposal_no", {
      header: "Proposal No",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.proposal_no}</div>,
    }),

    columnHelper.accessor("proposal_type", {
      header: "Proposal Type",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.proposal_type}</div>,
    }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.quantity}</div>,
    }),

    columnHelper.accessor("refinery", {
      header: "Refinery",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.refinery}</div>,
    }),

    columnHelper.accessor("day_of_month", {
      header: "Day of Month",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.day_of_month}</div>,
    }),

    columnHelper.accessor("frequency", {
      header: "Frequency",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.frequency}</div>,
    }),

    columnHelper.accessor("metal_type", {
      header: "Metal Type",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.metal_type}</div>,
    }),

    columnHelper.accessor("order_type", {
      header: "Order Type",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.order_type}</div>,
    }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.status}</div>,
    }),

    columnHelper.accessor("sip_status", {
      header: "SIP Status",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.sip_status}</div>,
    }),

    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.flag}</div>,
    }),

    columnHelper.accessor("subReferenceId", {
      header: "Sub Reference ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.subReferenceId}</div>,
    }),

    columnHelper.accessor("subscriptionId", {
      header: "Subscription ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.subscriptionId}</div>,
    }),

    columnHelper.accessor("is_deleted", {
      header: "Is Deleted",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.is_deleted}</div>,
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.createdAt).toLocaleDateString()}
        </div>
      ),
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.updatedAt).toLocaleDateString()}
        </div>
      ),
    }),
  ];

  return (
    <>
      {/*  */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: { xs: 1.5, md: 3 },
          // border: "1px solid grey",
          mb: { xs: 1, md: 3 },
          background: "#dcdaff",
          color: "#4d16a4",
          borderRadius: "6px",
        }}
      >
        <Box sx={{ marginLeft: { xs: 0 } }}>
          <Typography variant={{ xs: "h2" }} component="div">
            Total Amount
          </Typography>
          <Typography variant="body1" component="div" sx={{ paddingLeft: 1 }}>
            {/* Batuk Partner */}
          </Typography>
        </Box>
        <Box sx={{ marginRight: { xs: 0 } }}>
          <Typography variant={{ xs: "body1" }} component="div">
            ₹ {totalAmount}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={{ xs: 1, md: 3 }}>
        <Grid item xs={12}>
          <SearchFilterComponent
            sliceResponse={sliceResponse}
            onSearch={handleSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            columns={columns}
            data={bussinessSliceResponse}
            loading={stateLoading}
            permissionKey="SipBooked"
          />
        </Grid>
      </Grid>
    </>
  );
}
